import { CommonModule,formatCurrency,getCurrencySymbol } from '@angular/common';
import { AfterViewInit,Component,DEFAULT_CURRENCY_CODE,inject,Inject,LOCALE_ID,OnDestroy,ViewChild } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator,MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Sort } from '@angular/material/sort';
import { ResolveData } from '@angular/router';
import { Material } from '@dave/types';
import { MaterialFilterType,MaterialSortProperty } from '@dave/types/dist/proto/erp/material';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { BehaviorSubject,combineLatest,firstValueFrom,merge,Observable,Subject,switchMap } from 'rxjs';
import { debounceTime,distinctUntilChanged,filter,map,shareReplay, takeUntil,tap } from 'rxjs/operators';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { DatanormUploadDialogComponent,DatanormUploadDialogComponentDialogData,DatanormUploadDialogComponentDialogReturnData } from '../../../datanorm-upload-dialog/datanorm-upload-dialog.component';
import { MaterialGroupEntity } from '../../../dave-data-module/entities/material-group.entity';
import { CustomerResolver } from '../../../dave-data-module/guards/customer.resolver';
import { MaterialGroupResolver } from '../../../dave-data-module/guards/material-group.resolver';
import { QuantityTypeResolver } from '../../../dave-data-module/guards/quantity-type.resolver';
import { TokenResolver } from '../../../dave-data-module/guards/token.resolver';
import { UserResolver } from '../../../dave-data-module/guards/user.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { materialBackendSort,PaginatedMaterialService } from '../../../dave-data-module/services/paginated-material.service';
import { State } from '../../../dave-data-module/State';
import { ChangeSettings } from '../../../dave-data-module/State/actions/settings.actions';
import { customersFeatureKey } from '../../../dave-data-module/State/reducers/customers.reducer';
import { MATERIAL_GROUP_KEY } from '../../../dave-data-module/State/reducers/material-group.reducers';
import { usersFeatureKey } from '../../../dave-data-module/State/reducers/users.reducer';
import { getQuantityTypeDictionary,getQuantityTypesFetched } from '../../../dave-data-module/State/selectors/accounting.selector';
import { getCustomerDictionary,getCustomersFetched,getNotDeletedSuppliers } from '../../../dave-data-module/State/selectors/customers.selectors';
import { getMaterialGroupDictionary,getMaterialGroups,getMaterialGroupsFetched } from '../../../dave-data-module/State/selectors/material-group.selectors';
import { getPartner,getPartnerFetched } from '../../../dave-data-module/State/selectors/partners.selectors';
import { getSetting,getSettingFetched,getUserDictionary,getUsersFetched } from '../../../dave-data-module/State/selectors/users.selectors';
import { DaveDoubleIconModule } from '../../../dave-double-icon/dave-double-icon.module';
import { DaveListComponent,DaveListTableData } from '../../../dave-list/components/dave-list/dave-list.component';
import { DaveListModule } from '../../../dave-list/dave-list.module';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { FilterOption,FILTER_TYPE_SEARCH_MULTI_SELECT,IFilterTypeSearchMultiSelectValue } from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { DaveSharedComponentsModule } from '../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { isNotNullOrUndefined,SearchQueriesDebounceTime,TableColumnConfig } from '../../../helper/helper';
import { MaterialPageMeta,NewMaterialPageMeta } from '../../../helper/page-metadata';
import { LoadingService } from '../../../services/loading.service';
import { TableConfigFormComponent } from '../../../table-config-form/table-config-form.component';
import { WarehouseMovementComponent } from '../../../warehouse/warehouse-movement/warehouse-movement.component';

interface TableData extends DaveListTableData {
    Name: string;
    Kostenstelle: string;
    ArticleNumber: string;
    MainProductGroup: string;
    ProductGroup: string;
    routerLink: string | string[];
    id: number;
    cssClass?: string | string[] | Set<string> | { [klass: string]: any };
    clickable: boolean;
    Cost: string;
    QuantityType: string;
    SellQuantityType: string;
    Manufacturer: string;
    SellPrice: string;
    ProductGroupId: number;
    MainProductGroupId: number;
    Amount: number;
    ListPrice: string;
    User: string;
    InventoryNumber: string;
    StorageLocation: string;
    GlobalTradeItemNr: string;
    Supplier: string;
}
interface FilterValues {
    Hauptwarengruppe: IFilterTypeSearchMultiSelectValue<number>[];
    Warengruppe: IFilterTypeSearchMultiSelectValue<number>[];
    Lieferant: IFilterTypeSearchMultiSelectValue<number>[];
}
const tableSortToBackendSort = (sort: string): materialBackendSort => {
    switch (sort as keyof TableData) {
        case 'Amount':
            return MaterialSortProperty.Amount;
        case 'Kostenstelle':
            return MaterialSortProperty.Kostenstelle;
        case 'ArticleNumber':
            return MaterialSortProperty.ArticleNumber;
        case 'Manufacturer':
            return MaterialSortProperty.Manufacturer;
        case 'Name':
            return MaterialSortProperty.Name;
        case 'Cost':
            return MaterialSortProperty.Cost;
        case 'ListPrice':
            return MaterialSortProperty.ListPrice;
        case 'SellPrice':
            return MaterialSortProperty.SellPrice;
        case 'InventoryNumber':
            return MaterialSortProperty.InventoryNumber;
        case 'GlobalTradeItemNr':
            return MaterialSortProperty.GlobalTradeItemNr;
        case 'StorageLocation':
            return MaterialSortProperty.StorageLocation;
        default:
            return undefined;
    }
};
@Component({
    selector: 'app-material-list-view',
    templateUrl: './material-list-view.component.html',
    styleUrls: ['./material-list-view.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DaveListModule,
        DaveDoubleIconModule,
        AppButtonModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        TableConfigFormComponent,
        DaveSharedComponentsModule,
        MatPaginatorModule,
        MatBadgeModule,
        MatTooltipModule,
        FontAwesomeModule,
    ],
    providers: [PaginatedMaterialService],
})
export class MaterialListViewComponent implements AfterViewInit, OnDestroy {
    public static readonly RequiredResolvers: ResolveData = {
        token: TokenResolver,
        [MATERIAL_GROUP_KEY]: MaterialGroupResolver,
        [customersFeatureKey]: CustomerResolver,
        [usersFeatureKey]: UserResolver,
    };
    private readonly _materialService = inject(PaginatedMaterialService);
    public PageMetaMaterial = MaterialPageMeta;
    public NewMaterialPageMeta = NewMaterialPageMeta;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(DaveListComponent) appList: DaveListComponent<any>;
    private availableColumns: Array<keyof TableData> = [
        'Name',
        'Kostenstelle',
        'ArticleNumber',
        'MainProductGroup',
        'ProductGroup',
        'Amount',
        'Cost',
        'QuantityType',
        'SellQuantityType',
        'Manufacturer',
        'SellPrice',
        'ListPrice',
        'User',
        'InventoryNumber',
        'StorageLocation',
        'GlobalTradeItemNr',
        'Supplier',
    ];

    public TableColumns: TableColumnConfig<TableData>[] = [
        { header: 'Name', name: 'Name' },
        { header: 'Kostenstelle', name: 'Kostenstelle' },
        { header: 'Artikelnummer', name: 'ArticleNumber' },
        { header: 'Mengeneinheit', name: 'QuantityType' },
        { header: 'Verkaufseinheit', name: 'SellQuantityType' },
        { header: 'Hauptwarengruppe', name: 'MainProductGroup' },
        { header: 'Warengruppe', name: 'ProductGroup' },
        { header: 'Hersteller', name: 'Manufacturer' },
        { header: 'EK-Preis', name: 'Cost' },
        { header: 'VK-Preis', name: 'SellPrice' },
        { header: 'Menge', name: 'Amount' },
        { header: 'Listenpreis', name: 'ListPrice' },
        { header: 'Letzter Bearbeiter', name: 'User' },
        { header: 'Inventarnummer', name: 'InventoryNumber' },
        { header: 'Lagerplatz', name: 'StorageLocation' },
        { header: 'EAN', name: 'GlobalTradeItemNr' },
        { header: 'Lieferanten', name: 'Supplier' },
    ].map((c: TableColumnConfig<TableData>) => ({...c, sortDisabled: !tableSortToBackendSort(c.name)}));

    public MaterialDataSource$: Observable<TableVirtualScrollDataSource<TableData>>;

    public FilterValues$: BehaviorSubject<FilterValues> = new BehaviorSubject({
        Hauptwarengruppe: [],
        Warengruppe: [],
        Lieferant: [],
    });
    public PageIsLoading$ = this._materialService.selectIsLoading$;
    private afterViewInit$ = new BehaviorSubject(false);

    public FilterSettings$: Observable<FilterOption[]> = combineLatest([
        this.store.select(getMaterialGroups),
        this.store.select(getNotDeletedSuppliers)
    ]).pipe(
        map(([groups, suppliers]) => {
            const mainGroupFilterValues: IFilterTypeSearchMultiSelectValue<number>[] = groups
                .filter((g) => !g.ParentId)
                .map((r) => ({
                    label: r.Name,
                    id: r.Id,
                }));
            const subGroups = groups.filter((g) => !!g.ParentId);
            const supplierFilterValues: IFilterTypeSearchMultiSelectValue<number>[] = suppliers.map((s) => ({
                label: s.Name,
                id: s.Id,
            }));

            return { subGroups, mainGroupFilterValues, supplierFilterValues };
        }),
        switchMap(({ subGroups, mainGroupFilterValues, supplierFilterValues }) => {
            return combineLatest([
                this.FilterValues$.pipe(distinctUntilChanged((a, b) => JSON.stringify(a?.Hauptwarengruppe) === JSON.stringify(b?.Hauptwarengruppe))),
                this.cls.getSingle$('Supplier'),
            ]).pipe(
                map(([filterValues, supplierLabel]) => {
                    const subGroupFilterValues: IFilterTypeSearchMultiSelectValue<number>[] = subGroups
                        .filter((g) => (filterValues?.Hauptwarengruppe?.length ? filterValues.Hauptwarengruppe.some((f) => f.id === g.ParentId) : true))
                        .map((r) => ({
                            label: r.Name,
                            id: r.Id,
                        }));
                    return [
                        {
                            Name: 'Hauptwarengruppe',
                            Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                            Label: 'Hauptwarengruppe',
                            Values: mainGroupFilterValues,
                        },
                        {
                            Name: 'Warengruppe',
                            Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                            Label: 'Warengruppe',
                            Values: subGroupFilterValues,
                        },
                        {
                            Name: 'Lieferant',
                            Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                            Label: supplierLabel,
                            Values: supplierFilterValues,
                        },
                    ];
                }),
            );
        }),
    );
    length$ = this._materialService.selectLength$;
    pageSize$ = this._materialService.selectPageSize$;
    countLimitReached$ = this._materialService.selectIsCountLimitReached$;
    constructor(
        private store: Store<State>,
        quantityTypeResolver: QuantityTypeResolver,
        userResolver: UserResolver,
        @Inject(LOCALE_ID) private local: string,
        @Inject(DEFAULT_CURRENCY_CODE) private defaultCurrencyCode: string,
        private dialog: MatDialog,
        public LS: LoadingService,
        public cls: CustomLabelService,
    ) {
        firstValueFrom(this.store.select(getQuantityTypesFetched)).then((fetched) => {
            if (!fetched) {
                quantityTypeResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getUsersFetched)).then((fetched) => {
            if (!fetched) {
                userResolver.resolve();
            }
        });

        this.MaterialDataSource$ = combineLatest([
            getFetched$(this.store, getQuantityTypesFetched, getQuantityTypeDictionary),
            getFetched$(this.store, getMaterialGroupsFetched, getMaterialGroupDictionary),
            getFetched$(this.store, getUsersFetched, getUserDictionary),
            getFetched$(this.store, getCustomersFetched, getCustomerDictionary),
            this.selectedColumns$.pipe(
                map(selectedColumns => selectedColumns.includes('Supplier')),
                distinctUntilChanged(),
            ),
            this.afterViewInit$.pipe(filter(v=>v))
        ]).pipe(
            tap(() => {
                if(this.paginator) {
                    this.paginator.pageIndex = 0;
                }
            }),
            switchMap(([qtypes, materialGroupDic, users, customer, withSupplier]) =>
                merge(
                    this.sortChange$.pipe(tap(() => (this.paginator.pageIndex = 0))),
                    this.paginator.page,
                    this.FilterValues$.pipe(tap(() => (this.paginator.pageIndex = 0))),
                    this.searchChange$.pipe(
                        debounceTime(SearchQueriesDebounceTime),
                        tap(() => (this.paginator.pageIndex = 0)),
                    ),
                ).pipe(
                    // startWith(null), braucht nicht da filterValuesEin BehaviourSubject ist
                    tap(() => this.appList?.scrollTop()),
                    switchMap(() => {
                        const page = this.paginator;
                        const offset = page.pageIndex * page.pageSize;
                        const search = this.appList?.SearchForm?.value;
                        const sort = this.appList?.sort.active;
                        const sortDirection = this.appList?.sort.direction;
                        const filter = this.FilterValues$.value;
                        this._materialService.loadPage({
                            pageSize: page.pageSize,
                            offset,
                            searchQuery: search,
                            sortDirection: sortDirection || undefined,
                            sortProperty: tableSortToBackendSort(sort),
                            filterObject: {
                                withSupplier: withSupplier,
                                [MaterialFilterType.SupplierFilter]: filter?.Lieferant?.length ? filter.Lieferant.map(v => Number(v.id)) : undefined,
                                [MaterialFilterType.MaterialGroupTypeFilter]: filter?.Warengruppe?.length ? filter.Warengruppe.map(v => Number(v.id)) : undefined,
                                [MaterialFilterType.MaterialMainGroupTypeFilter]: filter?.Hauptwarengruppe?.length ? filter.Hauptwarengruppe.map(v => Number(v.id)) : undefined,
                            },
                        });
                        return this._materialService.selectItems$.pipe(
                            switchMap((materials) => {
                                console.log({ materials });
                                return this.selectedColumns$.pipe(
                                    // switchMap((selectedColumns) => {
                                    //     if (selectedColumns.includes('Supplier') && materials.length > 0) {
                                    //         return this.materialToSupplierDataService.getMaterialToSupplierByMaterialIds$(materials.map((m) => m.Id));
                                    //     } else {
                                    //         return of([] as MaterialToSupplierEntity[]);
                                    //     }
                                    // }),)
                                    map((selectedColumns) => {
                                        return new TableVirtualScrollDataSource<TableData>(
                                            materials.map((mat) => {
                                                const mainProductGroup: MaterialGroupEntity = materialGroupDic[materialGroupDic[mat?.ProductGroupId]?.ParentId];
                                                let customerName = '';
                                                if (mat.SupplierIds?.length) {
                                                    const customerNames = mat.SupplierIds.map((id) => customer[id]?.Name).filter((name) => name);
                                                    customerName = customerNames.join(', ') || '';
                                                }
                                                return {
                                                    Name: mat.Name,
                                                    ArticleNumber: mat.ArticleNumber,
                                                    id: mat.Id,
                                                    MainProductGroup: mainProductGroup?.Name,
                                                    ProductGroup: materialGroupDic[mat?.ProductGroupId]?.Name,
                                                    routerLink: mat.Id + '',
                                                    clickable: true,
                                                    tooltip: null,
                                                    Cost: mat.Cost ? formatCurrency(Number((mat.Cost / 100).toFixed(2)), this.local, getCurrencySymbol(this.defaultCurrencyCode, 'narrow', this.local), this.defaultCurrencyCode) : '',
                                                    QuantityType: mat?.QuantityTypeId ? qtypes[mat.QuantityTypeId]?.Name : null,
                                                    ProductGroupId: mat.ProductGroupId,
                                                    MainProductGroupId: mainProductGroup?.Id,
                                                    Manufacturer: mat.Manufacturer,
                                                    SellPrice: mat.SellPrice
                                                        ? formatCurrency(Number((mat.SellPrice / 100).toFixed(2)), this.local, getCurrencySymbol(this.defaultCurrencyCode, 'narrow', this.local), this.defaultCurrencyCode)
                                                        : '',
                                                    Kostenstelle: mat.Kostenstelle,
                                                    Amount: mat.Amount,
                                                    SellQuantityType: mat?.SellQuantityTypeId ? qtypes[mat.SellQuantityTypeId]?.Name : null,
                                                    ListPrice: mat.ListPrice
                                                        ? formatCurrency(Number((mat.ListPrice / 100).toFixed(2)), this.local, getCurrencySymbol(this.defaultCurrencyCode, 'narrow', this.local), this.defaultCurrencyCode)
                                                        : '',
                                                    User: mat.UserId ? this.formatUserName(users[mat.UserId]?.DisplayName) || 'Unbekannt' : '',
                                                    InventoryNumber: mat.InventoryNumber,
                                                    StorageLocation: mat.StorageLocation,
                                                    GlobalTradeItemNr: mat.GlobalTradeItemNr,
                                                    Supplier: customerName,
                                                };
                                            }),
                                        );
                                    }),
                                );
                            }),
                        );
                    }),
                ),
            ),
        );
    }

    ngOnDestroy(): void {
        this.FilterValues$.complete();
        this.afterViewInit$.complete();
        this.sortChange$.complete();
        this.searchChange$.complete();
    }

    onDatanormClick() {
        this.dialog.open<DatanormUploadDialogComponent, DatanormUploadDialogComponentDialogData, DatanormUploadDialogComponentDialogReturnData>(DatanormUploadDialogComponent, {
            ...DatanormUploadDialogComponent.DefaultConfig,
        });
    }

    protected readonly Material = Material;

    formatUserName(displayName: string): string {
        if (!displayName) {
            return '';
        }

        const [lastName, firstName] = displayName.split(',').map((namePart) => namePart.trim());

        if (!lastName || !firstName) {
            return displayName;
        }

        const formattedName = `${firstName.charAt(0)}${lastName.substring(0, 3)}`;

        return formattedName;
    }

    selectedColumns$: Observable<Array<keyof TableData>> = combineLatest([getFetched$(this.store, getSettingFetched, getSetting), getFetched$(this.store, getPartnerFetched, getPartner)]).pipe(
        map(([settings, partner]) => {
            if (settings.MaterialListComponentDisplayedColumns) {
                return settings.MaterialListComponentDisplayedColumns.map((k) => this.availableColumns.find((column) => column === k)).filter(isNotNullOrUndefined);
            } else if (partner.AdditionalData?.MaterialListComponentDisplayedColumns) {
                return partner.AdditionalData.MaterialListComponentDisplayedColumns.map((k) => this.availableColumns.find((column) => column === k)).filter(isNotNullOrUndefined);
            } else {
                return <Array<keyof TableData>>['ArticleNumber', 'Name', 'QuantityType', 'MainProductGroup', 'ProductGroup', 'Amount', 'Kostenstelle', 'SellPrice'];
            }
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    public TableColumnsSorted$: Observable<TableColumnConfig<TableData>[]> = this.selectedColumns$.pipe(
        map((selected) => {
            return this.TableColumns.sort((a, b) => selected.indexOf(a.name) - selected.indexOf(b.name));
        }),
    );

    selectedColumnsChange(selectedColumns: Array<keyof TableData>) {
        this.store.dispatch(
            new ChangeSettings({
                MaterialListComponentDisplayedColumns: selectedColumns,
            }),
        );
    }

    disabledColumns$ = combineLatest([this.TableColumnsSorted$, this.selectedColumns$]).pipe(map(([all, selected]) => all.length - selected.length || undefined));
    sortChange$ = new Subject<Sort>();
    searchChange$ = new Subject<string>();
    onAddWarehouseMovement() {
        this.dialog.open(WarehouseMovementComponent, {
            ...WarehouseMovementComponent.DefaultConfig,
        });
    }

    sortChange(sort: Sort) {
        this.sortChange$.next(sort);
    }
    searchChange(search: string) {
        this.searchChange$.next(search);
    }

    ngAfterViewInit(): void {
        this.afterViewInit$.next(true)
    }
}
